export default __webpack_public_path__ + "static/media/icone-instagram-redondo-branco.0ac477f3.svg";